const indexerUrl = "https://namada.blackblocks.io/indexer";
const rpcUrl = "https://namada-se-rpc.contributiondao.com";

const blockUrl = `${indexerUrl}/block`;
const txUrl = `${indexerUrl}/tx`;

export { blockUrl, txUrl, rpcUrl };
